module.exports = __webpack_public_path__ + "static/09-ce6bba2ef9152f5c79d788cd113bac6c.jpg";